let apidaePrestasSearch = {
    props: {
        title: String,
        nbPrestas: Number,
        type: String,
        params: Object,
        groupesFiltres: Array,
        lang: String,
        pmin: Number,
        pmax: Number,
        njmin: Number,
        njmax: Number,
        showTarif: Number,
        showFiltreDate: Number,
        showFiltreAge: Number,
        showFiltrePrice: Number,
        showFiltreCapacity: Number,
        showFiltreNombreChambres: Number,
        showFiltreNombreJours: Number,
        showFiltreNombreNuits: Number,
        showFiltreDistance: Number,
        showFiltreDuration: Number,
        showFiltreElevation: Number
    },
    components: {
        groupFilters,
        filtreDate,
        filtrePrice,
        filtreNombreJours
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        save() {
            this.$root.submitfilters(event)
        },
        away() {
            this.isDropdownActive = false;
        }
    },
    template: `
    <div class="sidebar-filter">
        <form class="Profiles form" @submit.prevent="save">
            <div class="searchBlockContent">
                <template v-if="groupeFiltres.hide" v-for="(groupeFiltres, index) in groupesFiltres">
                    <group-filters :groupe-filtres="groupeFiltres"></group-filters>
                </template>
                <filtre-price v-if="showFiltrePrice" :pmin="pmin" :pmax="pmax" />
                <filtre-nombre-jours v-if="showFiltreNombreJours" :njmin="njmin" :njmax="njmax" />
                <filtre-date v-if="showFiltreDate" :params="params" />
            </div>
        </form>
    </div>`
} 
